// extracted by mini-css-extract-plugin
export default {"shadowed":"BaseLayout_shadowed__-4IXS","dark":"BaseLayout_dark__Ux6UF","light":"BaseLayout_light__-o1KJ"};